module.exports = {
  header: 'Login',
  headerThankYou: 'Thank you',
  isLoginLink: false,
  agentTitle: 'If you\'re a travel agent',
  agentCallToAction: 'Agent Login',
  agentLoginLocation: '/login.php',
  customerLoginLocation: 'https://www.holidayextras.co.uk/customer-login.html',
  loginUnsuccessful: 'Login unsuccessful, please try the magic login link',
  customerTitle: 'Customer Login',
  emailAddress: 'Email Address',
  enterEmail: 'Enter your email address',
  password: 'Password',
  enterPassword: 'Enter password',
  customerCallToAction: 'Sign in',
  forgottenPassword: 'Forgotten password?',
  noValidUser: 'Oh no! We couldn’t find an account registered to that email address. Don’t worry, we can create you an account when you make your first booking.',
  magicLink: 'Forgotten Password. Email me a magic sign in link.',
  magicLinkUrl: 'X0Gzc2X%3DYQpglLjHJlYQGszei3FqTzgcrWhLC6rgwkGMmzaaUc4ERlbUk9CDRVwjpnpgHlpgneHmgJoXX0Gzc2X%3DYQpglLjHJlYQGkXTumvmw5tFLCtiihzazcPL8zaaUc4ERlbUk9CDR',
  magicLinkSent: 'Please check your inbox, we have sent your magic link login.'
}
